/**
 * @file  Loading/style.ts
 * @description  loading styles and props
 *
 * @example <Loading />
 *
 * @author ogarcia (ozkary)
 *
 */
import { ReactElement } from 'react';
import styled from 'styled-components';

// common container props
export interface Props {
  children?: ReactElement | ReactElement[];
  className?: string; // optional class override
}

// loading container
export const Container = styled.div<Props>`
  position: relative;
  width: 100%;  
  margin-right: auto;
  margin-left: auto; 
  class: ${(props) => props.className || ''}  
  overflow: hidden;  
  @media only screen and (max-width: 1024px) {
    max-width: 950px;
  }
  @media only screen and (max-width: 768px) {
    max-width: 700px;
  }
  @media only screen and (max-width: 414px) {
    max-width: 370px;
  }
`;

// loading icon element
export const Icon = styled.div`
  font-size: 100px;
`;

// loading text
export const Text = styled.div`
  font-size: 1.5rem;
`;

export const Header = styled.h3`
font-size: 2rem;
`;
